/* About.jsx */
import React from 'react';
import { motion } from 'framer-motion';
import { Code2, Briefcase, GraduationCap, Car } from 'lucide-react';
import '../Css/timeline.css';

const TimeLine = () => {
  const timelineItems = [
    {
      year: '2025 July - Present',
      title: 'Hamster POS | Full-Stack Developer',
      description: 'Worked with Spring Boot, Kafka, and microservices to build scalable backend systems. Developed web and mobile apps using Next.js and Flutter.',
      icon: <Briefcase />
    },
    {
      year: '2025 - May',
      title: 'B.S. in Computer Science',
      description: 'Graduated From lebanese international university',
      icon: <GraduationCap />
    },
    {
      year: '2024 November - 2025 June',
      title: 'TFC | Full-Stack Developer',
      description: 'Contributed to developing a real-world web application with a focus on backend development and web scraping using Meteor.js, enhancing data extraction and server-side functionality.',
      icon: <Briefcase />
    },
    {
      year: '2024 - august',
      title: 'My first hackathon',
      description: 'I participated in League Of Logic hackathon and I eraned 7th place',
      icon: <Code2 />
    },
    {
      year: '2024 - july',
      title: 'First Coding Competition',
      description: 'Built an autonomous car that can navigate through a maze using sensors and motors',
      icon: <Car />
    }
  ];
// B.S. in Computer Science
  return (
    <section id="about">
      <div className="container">
        <div className="content-wrapper">

          <div className="section-header">
            <div className="line"></div>
            <span className="title-tag">About Me</span>
          </div>

          <h2 className="main-title">My Journey</h2>

          <div className="intro-text">
            <p>
              I'm a passionate software developer with experience building modern software applications.
              I specialize in designing efficient systems and extracting meaningful data from complex sources.
            </p>
            <p>
             My approach combines technical expertise with a problem-solving mindset,
             ensuring the solutions I build are not only robust and scalable but also tailored to meet specific business needs.
            </p>
            <p>
              When I'm not coding, you can find me competing in chess tournaments, reading about new technologies,
              or sharpening my knowledge in different fields of computer science.
            </p>
          </div>

          <div className="timeline-wrapper">
            {timelineItems.map((item, index) => (
              <motion.div
                key={index}
                className="timeline-item"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <div className="icon-wrapper">{item.icon}</div>
                <div className="year">{item.year}</div>
                <h3 className="item-title">{item.title}</h3>
                <p className="item-desc">{item.description}</p>
              </motion.div>
            ))}
          </div>

          <div className="resume-wrapper">
            <a href="Mohamad Mourad.pdf" download className="resume-button">
              Download Resume
            </a>
          </div>

        </div>
      </div>
    </section>
  );
};

export default TimeLine;
